const state = {
    isAddRoutes: false,
    current: null, // 办理步骤
    twoCustomData: {}, // 步骤二数据
    applyInfo: {}, // 提交数据
}
const getters = {}

const mutations = {
    setIsAddRoutes(state, value) {
        state.isAddRoutes = value
    },
    setCurrent(state, value) {
        state.current = value
    },
    setTwoCustomData(state, value) {
        state.twoCustomData = value
    },
    setApplyInfo(state, value) {
        state.applyInfo = value
    }
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
};


// WEBPACK FOOTER //
// ./src/store/modules/temporary.js